import React from "react";
import T from "prop-types";

import Buttons, { ButtonsSet } from "2g-buttons";
import Form, { Field, Inputs, Row, ActionButton } from "2g-form";
import Widget from "2g-widget";
import { required } from "2g-validators-common";

import useMessages from "./i18n/useMessages";
import useSmlouvaVytvoreni from "./useSmlouvaVytvoreni";
import SchedulerWeeksComponent from "./SchedulerWeeksComponent";

const requiredValidator = required();

export function SmlouvaVytvoreni({ zakaznik }) {
  const {
    titleVytvoreni,
    titleEdit,
    buttonSubmitVytvoreni,
    buttonSubmitEdit,
    buttonCancel
  } = useMessages();
  const {
    formModuleKey,
    onSubmit,
    onCancel,
    isPouzito,
    isEdit,
    isDefaultNarokyHidden,
    loader
  } = useSmlouvaVytvoreni({
    zakaznik
  });
  return (
    <Widget
      title={
        isEdit
          ? `${titleEdit()}: ${loader.data?.cislo || ""}`
          : titleVytvoreni()
      }
      collapsable={false}
    >
      <Form
        moduleKey={formModuleKey}
        onSubmit={onSubmit}
        disabled={loader.loading || loader.error}
      >
        <Row styled>
          <Field
            component={Inputs.Input}
            path="cislo"
            disabled={isPouzito}
            label="b2b.smlouva-vytvoreni.field.cislo.label"
            required
            validators={requiredValidator}
          />
          <Field
            component={Inputs.Input}
            path="popis"
            label="b2b.smlouva-vytvoreni.field.popis.label"
          />
        </Row>
        <Row styled>
          <Field
            component={Inputs.DateTimePicker}
            date
            milliseconds
            path="platnostOd"
            label="b2b.smlouva-vytvoreni.field.platnostOd.label"
            disabled={isPouzito}
            required
            validators={requiredValidator}
          />
          <Field
            component={Inputs.DateTimePicker}
            date
            milliseconds
            path="platnostDo"
            label="b2b.smlouva-vytvoreni.field.platnostDo.label"
            disabled={isPouzito}
            required
            validators={requiredValidator}
          />
        </Row>

        <Row styled>
          <Field
            component={Inputs.Input}
            path="defaultMzo"
            type="number"
            step="1"
            min="0"
            required
            visible={!isDefaultNarokyHidden}
            label="b2b.smlouva-vytvoreni.field.fixMo.label"
          />
          <Field
            component={Inputs.Input}
            path="defaultVzo"
            type="number"
            step="1"
            min="0"
            required
            visible={!isDefaultNarokyHidden}
            label="b2b.smlouva-vytvoreni.field.fixVo.label"
          />
        </Row>

        <Row styled>
          <SchedulerWeeksComponent />
        </Row>
        <ButtonsSet>
          <ActionButton
            button={Buttons.Primary}
            validate
            submit
            inverse
            disabled={!isDefaultNarokyHidden}
          >
            {isEdit ? buttonSubmitEdit() : buttonSubmitVytvoreni()}
          </ActionButton>
          <ActionButton button={Buttons.Default} onClick={onCancel}>
            {buttonCancel()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

SmlouvaVytvoreni.propTypes = { zakaznik: T.object };

export default React.memo(SmlouvaVytvoreni);
